export const FETCH_AVAILABILITY = 'FETCH_AVAILABILITY';

export const availabilityAction = (availability) => ({
  type: FETCH_AVAILABILITY,
  payload: availability
});

